import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import NoiseWebWebp from '../../../../assets/noise/noise-details-banner-desktop.webp';
import NoiseMobileWebp from '../../../../assets/noise/noise-details-banner-mobile.webp';
import './NoiseInfoSection.scss';
import DisFeatureWeb from '../../../../assets/noise/dis-feature-web.webp';
import DisFeatureMobile from '../../../../assets/noise/dis-feature-mobile.webp';
const NoiseInfoSection = (props) => {
  const sliderRef = useRef(null);
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    autoplaySpeed: 3000,
  };
  return (
    <>
      {/* <!--HOme page banner section --> */}
      {/* <div>
        <h1>home page banner section</h1>
        <div className="noise-banner-section" ref={sliderRef}>
          <Slider {...settings}>
            <div className="always-connected-slider-card">
              <div className="always-connected-slider-image">
                <picture>
                  <source media="(max-width: 768px)" srcSet={NoiseMobileWebp} />
                  <img className="banner-image" src={NoiseWebWebp} alt="Banner" loading="lazy" />
                </picture>
              </div>
            </div>
            <div className="always-connected-slider-card">
              <div className="always-connected-slider-image">
                <picture>
                  <source media="(max-width: 768px)" srcSet={NoiseMobileWebp} />
                  <img className="banner-image" src={NoiseWebWebp} alt="Banner" loading="lazy" />
                </picture>
              </div>
            </div>
          </Slider>
        </div>
      </div> */}

      <div id="info-section" className="noiseinfo-section" data-aos="fade-up">
        <div className="info-container-web">
          <img src={DisFeatureWeb} className="" />
        </div>
        <div className="info-container-mobile">
          <img src={DisFeatureMobile} className="" />
        </div>
      </div>
    </>
  );
};

export default React.memo(NoiseInfoSection);
